import { useState } from "react";

import BookingsList from "./BookingsList";
import PendingBookingsList from "./PendingBookingsList";
import BlackoutComponent from "./Blackout/Blackout";
import "./ManageBookings.css";

function ManageBookings() {
  const [activeTab, setActiveTab] = useState("confirmed");

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="manageBookings">
      <BlackoutComponent />
      <div
        className="bookingsTabs"
        role="tablist"
        aria-label="Booking status views"
      >
        <button
          type="button"
          id="bookings-tab-confirmed"
          role="tab"
          aria-selected={activeTab === "confirmed"}
          aria-controls="bookings-panel-confirmed"
          className={`bookingsTabs__button${
            activeTab === "confirmed" ? " is-active" : ""
          }`}
          onClick={() => handleTabChange("confirmed")}
        >
          Confirmed bookings
        </button>
        <button
          type="button"
          id="bookings-tab-pending"
          role="tab"
          aria-selected={activeTab === "pending"}
          aria-controls="bookings-panel-pending"
          className={`bookingsTabs__button${
            activeTab === "pending" ? " is-active" : ""
          }`}
          onClick={() => handleTabChange("pending")}
        >
          Pending bookings
        </button>
      </div>
      <div
        role="tabpanel"
        id={`bookings-panel-${activeTab}`}
        aria-labelledby={`bookings-tab-${activeTab}`}
      >
        {activeTab === "pending" ? <PendingBookingsList /> : <BookingsList />}
      </div>
    </div>
  );
}

export default ManageBookings;
